if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer) return;

        console.log('✅ Media Gallery Initialized');

        // ✅ ONLY REAL SLIDES
        this.getSlides = () =>
          Array.from(
            this.elements.viewer.querySelectorAll(
              '[data-media-id].product__media-item'
            )
          );

        const slides = this.getSlides();

        // ✅ Ensure first active
        if (!this.elements.viewer.querySelector('.is-active') && slides.length) {
          slides[0].classList.add('is-active');
        }

        // 🔥 BUTTONS
        this.prevButton = this.querySelector('.slider-button--prev');
        this.nextButton = this.querySelector('.slider-button--next');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.showPrevious.bind(this));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.showNext.bind(this));
        }

        // 🔥 THUMBNAILS CLICK (FIXED)
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            thumb.querySelector('button')?.addEventListener('click', () => {
              console.log('🖱 Thumbnail clicked:', thumb.dataset.target);
              this.setActiveMedia(thumb.dataset.target, false);
            });
          });
        }

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 300)
        );
      }

      // ✅ NEXT
      showNext() {
        const items = this.getSlides();
        let active = this.elements.viewer.querySelector(
          '.product__media-item.is-active'
        );

        if (!active) active = items[0];

        let index = items.indexOf(active);
        index = (index + 1) % items.length;

        const nextItem = items[index];
        this.setActiveMedia(nextItem.dataset.mediaId, false);
      }

      // ✅ PREVIOUS
      showPrevious() {
        const items = this.getSlides();
        let active = this.elements.viewer.querySelector(
          '.product__media-item.is-active'
        );

        if (!active) active = items[0];

        let index = items.indexOf(active);
        index = (index - 1 + items.length) % items.length;

        const prevItem = items[index];
        this.setActiveMedia(prevItem.dataset.mediaId, false);
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      // 🔥 MAIN FIX FUNCTION
      setActiveMedia(mediaId, prepend) {
        console.log('🔄 Switching to:', mediaId);

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"].product__media-item`
          ) || this.getSlides()[0];

        if (!activeMedia) return;

        // ✅ REMOVE ACTIVE FROM ALL SLIDES
        this.getSlides().forEach((el) => {
          el.classList.remove('is-active');
        });

        // ✅ ADD ACTIVE TO CURRENT
        activeMedia.classList.add('is-active');

        // 🔥 SCROLL MAIN SLIDER
        setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'smooth',
          });
        });

        // 🔥 PLAY MEDIA
        this.playActiveMedia(activeMedia);

        // 🔥 UPDATE THUMBNAIL (IMPORTANT)
        if (this.elements.thumbnails) {
          const activeThumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

          this.setActiveThumbnail(activeThumbnail);
        }
      }

      // 🔥 THUMBNAIL ACTIVE STATE
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        console.log('🎯 Highlight thumbnail:', thumbnail);

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((btn) => btn.removeAttribute('aria-current'));

        const btn = thumbnail.querySelector('button');
        if (btn) {
          btn.setAttribute('aria-current', true);
        }

        // 🔥 AUTO SCROLL THUMBNAILS
        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
    }
  );
}